import React, { useState } from 'react';
import axios from 'axios';

const WaitlistForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');
    setError('');

    try {
      const response = await axios.post('/api/waitlist/join', { email });
      setMessage(response.data.message);
      setEmail('');
    } catch (err: any) {
      if (axios.isAxiosError(err) && err.response) {
        setError(err.response.data.message);
      } else {
        setError('An unexpected error occurred.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id="join-waitlist" className="text-center">
      <div className="max-w-2xl mx-auto">
        <div className="bg-card-gradient backdrop-blur-sm rounded-3xl p-12 border border-purple-800/50 shadow-dark mx-auto max-w-2xl">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="relative">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                required
                className="w-full bg-black/50 text-white px-8 py-5 rounded-2xl border border-purple-700/50 focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent transition-all duration-300 placeholder-gray-400 text-lg backdrop-blur-sm shadow-sm"
                disabled={isLoading}
              />
            </div>
            
            <button
              type="submit"
              className="w-full bg-gradient-purple text-white font-semibold py-5 px-8 rounded-2xl text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-button disabled:opacity-50 disabled:transform-none disabled:hover:shadow-none focus:outline-none focus:ring-2 focus:ring-purple-400 focus:ring-offset-2 focus:ring-offset-black"
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-3 h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Joining Waitlist...
                </div>
              ) : (
                <div className="flex items-center justify-center">
                  <span>Join Waitlist</span>
                  <svg className="ml-3 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </div>
              )}
            </button>
          </form>
          
          {message && (
            <div className="mt-8 p-6 bg-green-900/30 border border-green-700/50 rounded-2xl">
              <div className="flex items-center">
                <svg className="w-6 h-6 text-green-400 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <p className="text-green-300 font-medium text-lg">{message}</p>
              </div>
            </div>
          )}
          
          {error && (
            <div className="mt-8 p-6 bg-red-900/30 border border-red-700/50 rounded-2xl">
              <div className="flex items-center">
                <svg className="w-6 h-6 text-red-400 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <p className="text-red-300 font-medium text-lg">{error}</p>
              </div>
            </div>
          )}
          
          <div className="mt-8 text-center">
            <p className="text-gray-400">
              <span className="font-medium">100% free</span> • No spam • Unsubscribe anytime
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WaitlistForm; 